import butterCategoryCoverImage from '../../../assets/images/butter/butterCategoryCoverImage.webp'
import butterImage1 from '../../../assets/images/butter/butter-extra-82-5-fat-pastoral-200g.webp'
import butterImage2 from '../../../assets/images/butter/butter-selyanske-72-5-fat-pastoral-200g.webp'
import gheeImage from '../../../assets/images/butter/ghee-99-fat-pastoral-200g.webp'
import butterCategoryCoverImageMobile from '../../../assets/images/butter/butterCategoryCoverImageMobile.webp'


export const ButterProductsArr = [
    {
        path: "/butter/butter-extra-82-5-fat-pastoral-200g/",
        category: "butter",
        metaTitle: "Масло солодковершкове екстра 82,5 % жиру ТМ «Pastoral»",
        metaDescription: "Масло солодковершкове екстра 82,5 % жиру ТМ «Pastoral»",
        coverImage: butterCategoryCoverImage,
        coverImageMobile: butterCategoryCoverImageMobile,
        coverTitle: "Масло вершкове",
        aboutImage: butterImage1,
        aboutTitle: "Масло солодковершкове екстра 82,5 % жиру ТМ «Pastoral» 200 g (г)",
        aboutStats: [
            "0,5 g (г)", "82,5 g (г)", "0,8 g (г)", "748 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "200 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Фольга",
            },
            {
                title: "Склад: ",
                desc: "Вершки з коров’ячого молока",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>від 0°С до -5°С – 3 міс; від -6°С до -11°С – 9 міс; від -12°С до -18°С – 12 міс – для моноліту <br/> від 0°С до -5°С – 35 діб; від -6°С до -11°С – 60 діб; від -12°С до -18°С – 75 діб – для фасовки </>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ДСТУ 4399:2005",
            },
        ],
        categoryInfo: [
            "Виготовлено із 100% натуральних вершків.",
            "Європейська технологія збивання для ідеальної текстури",
            "Без додавання штучних консервантів та добавок.",
            "Натуральне джерело білку, вітамінів для краси та здоров’я",
    
        ],
    },
    {
        path: "/butter/butter-selyanske-72-5-fat-pastoral-200g/",
        category: "butter",
        metaTitle: "Масло солодковершкове селянське 72,5 % жиру ТМ «Pastoral»",
        metaDescription: "Масло солодковершкове селянське 72,5 % жиру ТМ «Pastoral»",
        coverImage: butterCategoryCoverImage,
        coverImageMobile: butterCategoryCoverImageMobile,
        coverTitle: "Масло вершкове",
        aboutImage: butterImage2,
        aboutTitle: "Масло солодковершкове селянське 72,5 % жиру ТМ «Pastoral» 200 g (г)",
        aboutStats: [
            "0,8 g (г)", "72,5 g (г)", "1,3 g (г)", "661 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "200 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Фольга",
            },
            {
                title: "Склад: ",
                desc: "Вершки з коров’ячого молока",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>від 0°С до -5°С – 3 міс; від -6°С до -11°С – 9 міс; від -12°С до -18°С – 12 міс – для моноліту <br/> від 0°С до -5°С – 35 діб; від -6°С до -11°С – 60 діб; від -12°С до -18°С – 75 діб – для фасовки </>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ДСТУ 4399:2005",
            },
        ],
        categoryInfo: [
            "Виготовлено із 100% натуральних вершків.",
            "Європейська технологія збивання для ідеальної текстури",
            "Без додавання штучних консервантів та добавок.",
            "Натуральне джерело білку, вітамінів для краси та здоров’я",
    
        ],
    },
    {
        path: "/butter/ghee-99-fat-pastoral-200g/",
        category: "butter",
        metaTitle: "Топлене масло  99,0 % жиру ТМ «Pastoral» масло ГХІ",
        metaDescription: "Топлене масло  99,0 % жиру ТМ «Pastoral» масло ГХІ",
        coverImage: butterCategoryCoverImage,
        coverImageMobile: butterCategoryCoverImageMobile,
        coverTitle: "Масло вершкове",
        aboutImage: gheeImage,
        aboutTitle: "Топлене масло  99,0 % жиру ТМ «Pastoral» масло ГХІ 200 g (г)",
        aboutStats: [
            "0,1 g (г)", "99 g (г)", "0,3 g (г)", "892 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "500 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Скло",
            },
            {
                title: "Склад: ",
                desc: "Масло солодковершкове",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>від 0℃ до -5℃ – 2 міс; від -6℃ до -11℃ – 3 міс; від -12℃ до -18℃ – 4 міс</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ДСТУ 4399:2005",
            },
        ],
        categoryInfo: [
            "Виготовлено із 100% натуральних вершків.",
            "Європейська технологія збивання для ідеальної текстури",
            "Без додавання штучних консервантів та добавок.",
            "Натуральне джерело білку, вітамінів для краси та здоров’я",
    
        ],
    },
]
